export default __webpack_public_path__ + "static/media/ico_home_gray.57fc9470.svg";